import { useRouter } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";

export function DefaultErrorComponent({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();
  console.error(error);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="mx-auto size-16 rounded-full bg-destructive/10 grid place-items-center">
          <AlertTriangle className="size-8 text-destructive" />
        </div>
        <div className="space-y-2">
          <h1 className="text-xl font-semibold tracking-tight text-foreground">
            Seite konnte nicht geladen werden
          </h1>
          <p className="text-sm text-muted-foreground">
            Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut oder kehre zur
            Startseite zurück.
          </p>
        </div>
        {error.message && (
          <div className="rounded-lg border border-destructive/20 bg-destructive/5 p-3">
            <p className="text-xs font-mono text-destructive break-all">{error.message}</p>
          </div>
        )}
        <div className="flex flex-wrap justify-center gap-3">
          <Button
            onClick={() => {
              router.invalidate();
              reset();
            }}
          >
            <RotateCcw className="size-4 mr-2" />
            Erneut versuchen
          </Button>
          <Button variant="outline" onClick={() => router.navigate({ to: "/" })}>
            <Home className="size-4 mr-2" />
            Startseite
          </Button>
        </div>
      </div>
    </div>
  );
}
